module.exports = __webpack_public_path__ + "static/media/road-C-photo.f049867a.svg";